export default {
  en_AU: {

  },
};
